/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lifecycle_Banner_ProductInputs */

const en_lifecycle_banner_product = /** @type {(inputs: Lifecycle_Banner_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This product is archived. It is read-only and hidden from the sidebar, lists and search.`)
};

const de_lifecycle_banner_product = /** @type {(inputs: Lifecycle_Banner_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Produkt ist archiviert. Es ist schreibgeschützt und in Seitenleiste, Listen und Suche ausgeblendet.`)
};

/**
* | output |
* | --- |
* | "This product is archived. It is read-only and hidden from the sidebar, lists and search." |
*
* @param {Lifecycle_Banner_ProductInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_banner_product = /** @type {((inputs?: Lifecycle_Banner_ProductInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Banner_ProductInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_banner_product(inputs)
	return en_lifecycle_banner_product(inputs)
});